module.exports = __webpack_public_path__ + "static/media/logo.7d3d0e05.png";